import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { trackEvent } from 'dibs-tracking';
import { createFragmentContainer, graphql } from 'react-relay';

import styles from './AccountNav-style.scss';

export const ENROLLED_LOYALTY_STATUS = 'ENROLLED';
export const ELIGIBLE_LOYALTY_STATUS = 'ELIGIBLE';
const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
};

class AccountNavDropdownContent extends React.Component {
    constructor(props) {
        super(props);
        this.onLogoutClick = this.onLogoutClick.bind(this);
        this.showTradeRewardsItem = this.showTradeRewardsItem.bind(this);
    }

    onLogoutClick() {
        trackEvent(Object.assign({}, trackingObj, { label: 'user-nav|logout' }));
        this.props.logoutUser();
    }

    showTradeRewardsItem() {
        return [ENROLLED_LOYALTY_STATUS, ELIGIBLE_LOYALTY_STATUS].includes(
            this.props.tradeLoyaltyStatus
        );
    }

    render() {
        const { totalUnreadConversations, viewer } = this.props;
        const { isMessageCenterEnabled } = viewer;

        return (
            <div className={styles.dropdownContent}>
                <div
                    className={styles.dropdownLinkWrapper}
                    data-tn="sub-nav-list-item-account-information"
                >
                    <a
                        className={styles.dropdownLink}
                        href="/my/account/"
                        data-tn="sub-nav-list-item-link-account-information"
                        onClick={() => {
                            trackEvent(
                                Object.assign({}, trackingObj, {
                                    label: 'user-nav|account information',
                                })
                            );
                        }}
                    >
                        <FormattedMessage
                            id="dbl.Header.AccountNavContent.account_information"
                            defaultMessage="Account Information"
                        />
                    </a>
                </div>
                <div className={styles.dropdownLinkWrapper} data-tn="sub-nav-list-item-my-orders">
                    <a
                        className={styles.dropdownLink}
                        href="/my/orders/"
                        data-tn="sub-nav-list-item-link-my-orders"
                        onClick={() => {
                            trackEvent(
                                Object.assign({}, trackingObj, { label: 'user-nav|my orders' })
                            );
                        }}
                    >
                        <FormattedMessage
                            id="dbl.Header.AccountNavContent.my_orders"
                            defaultMessage="My Orders"
                        />
                    </a>
                </div>

                {isMessageCenterEnabled && (
                    <div
                        className={styles.dropdownLinkWrapper}
                        data-tn="sub-nav-list-item-my-conversations"
                    >
                        <a
                            className={styles.dropdownLink}
                            href="/my/conversations/"
                            data-tn="sub-nav-list-item-link-my-conversations"
                            onClick={() => {
                                trackEvent(
                                    Object.assign({}, trackingObj, {
                                        label: 'user-nav|my conversations',
                                    })
                                );
                            }}
                        >
                            <FormattedMessage
                                id="dbl.Header.AccountNavContent.my_conversations"
                                defaultMessage="My Conversations"
                            />
                            {totalUnreadConversations ? (
                                <span className={styles.unreadCount}>
                                    {' '}
                                    ({totalUnreadConversations})
                                </span>
                            ) : null}
                        </a>
                    </div>
                )}

                {this.showTradeRewardsItem() && (
                    <div className={styles.dropdownLinkWrapper} data-tn="sub-nav-list-item-loyalty">
                        <a
                            className={styles.dropdownLink}
                            data-tn="sub-nav-list-item-link-loyalty"
                            href="/trade/loyalty/rewards/"
                        >
                            <FormattedMessage
                                id="dbl.Header.AccountNavContent.my_rewards"
                                defaultMessage="My Rewards"
                            />
                        </a>
                    </div>
                )}
                <div className={styles.dropdownLinkWrapper} data-tn="sub-nav-list-item-logout">
                    <span
                        className={styles.dropdownLink}
                        data-tn="sub-nav-list-item-link-logout"
                        onClick={this.onLogoutClick}
                    >
                        <FormattedMessage
                            id="dbl.Header.AccountNavContent.logout"
                            defaultMessage="Logout"
                        />
                    </span>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ header }) => {
    const { logoutUser } = header;
    return {
        logoutUser,
    };
};

AccountNavDropdownContent.propTypes = {
    totalUnreadConversations: PropTypes.number,
    tradeLoyaltyStatus: PropTypes.string,
    logoutUser: PropTypes.func,
};

export default createFragmentContainer(connect(mapStateToProps)(AccountNavDropdownContent), {
    viewer: graphql`
        fragment AccountNavContent_viewer on Viewer {
            isMessageCenterEnabled: isEnabledByLocale(featureName: "MESSAGE_CENTER")
        }
    `,
});
